import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import { actions as projectActions } from "store/actions";
import { scrollIntoView } from "utils/helper";

function UsePayoneerInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const onEditPayoneer = async (values) => {
    try {
      setIsLoading(true);
      const payload = {
        payoneerDetails: { payoneerEmail: values?.payoneer || undefined },
      };

      dispatch(
        projectActions.updatePayoneerCommon(payload, (ok, err) => {
          if (ok) {
            const updatedUser = {
              ...userDetails,
              bankDetails: {
                ...userDetails?.bankDetails,
                payoneerEmail: values?.payoneer || undefined,
              },
            };
            dispatch(actions.setUserDetails(updatedUser));
            notifySuccess("Has been updated successfully");
            scrollIntoView("payoneerSection");
          } else {
            notifyError(
              err?.data?.error ?? err?.message ?? "Something went wrong!"
            );
          }
        })
      );
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => () => {}, []);

  return { onEditPayoneer, isPayoneerLoading: isLoading };
}

export default UsePayoneerInformation;
